import axios from "./configAxios";

export const getTerminalDetailsApi = async (terminal_id) => {
    return await axios.get(`/${terminal_id}/detail/`)
}